<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('catalogue.popUpAddNewProduitDivers.title')}}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content mgb-20px">
        <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <produit-infos :produit="produit"
                       :afficher-logo="false"
                       :afficher-pj="false"
                       :produit-details="produit.produitDivers"></produit-infos>
        <div class="mgt-20px">
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction mgb-20px">
            <a class="button is-addOrEdit" @click="insertProduitDivers">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import produitInfos from '@/components/catalogue/produitGeneral/m_produit';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import cloneDeep from 'lodash/cloneDeep';
import { create } from '@/api/produit/produitDivers';
import messageSucces from '@/services/general/messageSucces';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/catalogue/validation/champsProduitTranslator';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'popUpAjoutProduitDivers',
  props: {
    produit: {
      type: Object,
      required: false,
    },
  },
  components: {
    produitInfos,
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  methods: {
    async insertProduitDivers() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const produit = cloneDeep(this.produit);
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.error = false;
        const produitDivers = (await create(produit)).data.result;
        messageSucces(this.$i18n.t('catalogue.addSuccess'));
        this.$emit('produitCreated', produitDivers);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          this.messages = validationProduit(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
};
</script>

<style scoped>

</style>
